import React from 'react';
import {useSelector} from 'react-redux';

import {selectDeviceBattery} from '@/state/selectors/device';

import Battery from './Battery';

const BatteryContainer = (props) => {
    const battery = useSelector(selectDeviceBattery) || 1;

    return <Battery percentage={battery} {...props} />;
};

export default BatteryContainer;
